import { axios, Response } from '../../index'

export interface Body {
  title: string
  favoriteChecklistItems: FavoriteChecklistItem[]
  companyOrUserEntity: string
}

export interface FavoriteChecklistItem {
  title: string
}

const createChecklistModel = (body: Body): Response<null> => {
  return axios.post('/v1/favorites/favorite-checklists/', body)
}

export default createChecklistModel
